<!--
  a11y: mobile-only map slide-up. Audit asked for focus to be locked inside
  every overlay slide-up and pulled to the back/close chevron on open. The
  outer overlay focus trap is set up by OverlayComponent; we just need to
  flag the header back button via focusInitialOnHeaderBack so it actually
  receives focus instead of leaving it stranded behind the map.
-->
<ng-container *ngIf="!!isMobile && !!isCard; else mapTemplate">
    <design-slide-up-card #card [isCardOpen]="!!isCardOpen" [displayBackground]="true" [title]="data.title"
        [roleDialog]="true"
        [focusInitialOnHeaderBack]="true"
        (onHeaderButtonClick)="closeCard(); onMapClose.emit()" icon="chevron-right" class="max-h-full">
        <ng-container *ngTemplateOutlet="mapTemplate"></ng-container>
    </design-slide-up-card>
</ng-container>

<ng-template #mapTemplate>
    <div #map id="map" class="w-full relative flex-1">
        <ng-container *ngIf="!hasErrorLoadingMap; else errorTemplate">
            <ng-content></ng-content>
            <div *ngIf="!mapInitialized" class="absolute inset-0 flex items-center justify-center z-10 pointer-events-none">
                <mat-spinner />
            </div>
        </ng-container>
        <ng-template #errorTemplate>
            <div class="error">Error loading map</div>
        </ng-template>
    </div>
</ng-template>
